function normalizeAshleyConversationTranscript(transcript) {
  return String(transcript || "")
    .toLowerCase()
    .replace(/['’]/g, "")
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

const AFFIRMATION_PHRASES = Object.freeze([
  "yes",
  "yeah",
  "yep",
  "sure",
  "please",
  "ok",
  "okay",
  "open it",
  "open inbox",
  "open my inbox",
  "open my emails",
  "open emails",
  "open gmail",
]);

const DECLINE_PHRASES = Object.freeze([
  "no",
  "nope",
  "no thanks",
  "no thank you",
  "not now",
  "dont",
  "do not",
  "cancel",
]);

export function isAshleyAffirmationPhrase(transcript) {
  const normalized = normalizeAshleyConversationTranscript(transcript);
  if (!normalized) {
    return false;
  }
  return AFFIRMATION_PHRASES.some(
    (phrase) => normalized === phrase || normalized.startsWith(`${phrase} `),
  );
}

export function isAshleyDeclinePhrase(transcript) {
  const normalized = normalizeAshleyConversationTranscript(transcript);
  if (!normalized) {
    return false;
  }
  return DECLINE_PHRASES.some(
    (phrase) => normalized === phrase || normalized.startsWith(`${phrase} `),
  );
}
